import { html, css, unsafeCSS, nothing } from 'lit';
import SotbitTag from '../tag';
import styles from './tag.scss?inline';
import { isValidCssColor } from '@/helpers/color.js';

export default class SotbitTagPromo extends SotbitTag {
    static styles = [
        SotbitTag.styles,
        css`
            ${unsafeCSS(styles)}
        `,
    ];

    render() {
        const styleTemplate = html`<style>
            :host {
                ${isValidCssColor(this.bgColor) ? `--tag-background: ${this.bgColor};` : ''}
                ${isValidCssColor(this.color) ? `--tag-color: ${this.color};` : ''}
            }
        </style>`;

        return html`
            ${this.bgColor || this.color ? styleTemplate : nothing}
            <div class="tag" part="tag">
                <div class="content">
                    <slot name="icon-start"></slot>
                    <span class="text" part="text"><slot></slot></span>
                    <slot name="icon-end"></slot>
                </div>
            </div>
        `;
    }
}
